class PlanPickerV2Ab extends HTMLElement {
  connectedCallback() {
    this.classList.remove('hidden');
    this.activeType = 'subscription';
    this.variantSelects = this.closest('variant-selects');

    this.querySelectorAll('.v2-toggle-btn').forEach(btn => {
      btn.addEventListener('click', () => this.switchType(btn.dataset.type));
    });

    this.querySelectorAll('.v2-option-pill').forEach(pill => {
      pill.addEventListener('click', () => this.selectOption(pill));
    });

    this.init();
  }

  init() {
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('variant');

    if (variantParam) {
      const subPill = this.querySelector(
        `.v2-panel[data-panel="subscription"] .v2-option-pill[data-variant-id="${variantParam}"]`
      );
      const otPill = this.querySelector(
        `.v2-panel[data-panel="onetimer"] .v2-option-pill[data-variant-id="${variantParam}"]`
      );
      const pillById = subPill || otPill;
      if (pillById) {
        const type = pillById.closest('.v2-panel')?.dataset.panel;
        if (type) this.switchType(type);
        this.selectOption(pillById);
        return;
      }

      const matchingInfo = this.variantSelects?.querySelector(`.option__info[data-variant-id="${variantParam}"]`);
      if (matchingInfo) {
        const type = matchingInfo.dataset.type;
        const nameEl = matchingInfo.querySelector('.option__info-name span.h5');
        const optionName = nameEl?.textContent.trim();
        if (optionName && type) {
          const escapedName = optionName.replace(/"/g, '\\"');
          const pill = this.querySelector(`.v2-panel[data-panel="${type}"] .v2-option-pill[data-value="${escapedName}"]`);
          if (pill) {
            this.switchType(type);
            this.selectOption(pill);
            return;
          }
        }
      }

      return;
    }

    if (window.isGoogleAdsCampaignTraffic?.()) {
      const firstSubPill = this.querySelector('.v2-panel[data-panel="subscription"] .v2-option-pill');
      if (firstSubPill) this.selectOption(firstSubPill);
      return;
    }

    const currentSelect = parseInt(this.variantSelects?.dataset.currentSelect || '0', 10);
    if (currentSelect > 0) {
      const packageFieldset = this.variantSelects?.querySelector('.product-options_package');
      const checkedInput = packageFieldset?.querySelector('input[type="radio"]:checked');
      const label = checkedInput ? packageFieldset?.querySelector(`label[for="${checkedInput.id}"]`) : null;
      const optionInfo = label?.querySelector('.option__info');

      if (optionInfo) {
        const type = optionInfo.dataset.type || 'subscription';
        const nameEl = optionInfo.querySelector('.option__info-name span.h5');
        const optionName = nameEl?.textContent.trim();

        if (optionName) {
          const escapedName = optionName.replace(/"/g, '\\"');
          const pill = this.querySelector(`.v2-panel[data-panel="${type}"] .v2-option-pill[data-value="${escapedName}"]`);
          if (pill) {
            this.switchType(type);
            this.selectOption(pill);
            return;
          }
        }
      }

      if (label) {
        label.click();
        return;
      }
    }

    const firstSubPill = this.querySelector('.v2-panel[data-panel="subscription"] .v2-option-pill');
    if (firstSubPill) this.selectOption(firstSubPill);
  }

  switchType(type) {
    if (this.activeType === type) return;
    this.activeType = type;
    this.dataset.currentType = type;

    this.querySelectorAll('.v2-toggle-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.type === type);
    });

    this.querySelectorAll('.v2-panel').forEach(panel => {
      panel.classList.toggle('hidden', panel.dataset.panel !== type);
    });

    this.variantSelects?.lockSubmitUntilVariantSettled?.();

    if (this.variantSelects?.updatePurchaseTypeInput) this.variantSelects.updatePurchaseTypeInput(type);
    if (this.variantSelects?.toggleProductFormInput) this.variantSelects.toggleProductFormInput(type);

    const activePill = this.querySelector(`.v2-panel[data-panel="${type}"] .v2-option-pill.active`);
    if (activePill) {
      this.updateDynamicBullets(activePill);
      this.triggerRadioForPill(activePill, type);
    }

    this.variantSelects?.unlockSubmitIfVariantIdle?.();

    const titleWrappers = this.variantSelects?.querySelectorAll('.variant-titles__wrapper .h5');
    titleWrappers?.forEach(el => el.classList.toggle('hidden', el.dataset.type !== type));

    const sectionId = this.dataset.section;
    const productForm = document.querySelector(`product-form[data-section-id="${sectionId}"]`);
    if (productForm?.togglePrices) productForm.togglePrices();
  }

  selectOption(pill) {
    const panel = pill.closest('.v2-panel');
    if (!panel) return;

    const type = panel.dataset.panel;

    panel.querySelectorAll('.v2-option-pill').forEach(p => p.classList.remove('active'));
    pill.classList.add('active');

    this.updateInfoBar(pill, type);
    this.updateDynamicBullets(pill);
    this.triggerRadioForPill(pill, type);
  }

  updateDynamicBullets(pill) {
    const panel = pill.closest('.v2-panel');
    if (!panel) return;
    const list = panel.querySelector('.v2-bullets');
    if (!list) return;

    list.querySelectorAll('.v2-bullet-dynamic').forEach(el => el.remove());

    const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M13.5 6L7.53374 12L5.5 9.95476" stroke="#494C57" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const keys = ['package', 'line1', 'line2', 'line3', 'line4'];
    const texts = keys.map(k => pill.dataset[k]).filter(Boolean).reverse();

    texts.forEach(text => {
      const li = document.createElement('li');
      li.className = 'v2-bullet v2-bullet-dynamic flex items-center space-x0-5';
      li.innerHTML = `${svg}<span class="text-body-md">${text}</span>`;
      list.prepend(li);
    });
  }

  updateInfoBar(pill, type) {
    const prefix = type === 'subscription' ? 'sub' : 'ot';
    const priceEl = this.querySelector(`#item_${prefix}_price`);
    const totalEl = this.querySelector(`#item_${prefix}_total`);
    const strikeEl = this.querySelector(`#item_${prefix}_strike_price`);

    if (priceEl && pill.dataset.price) {
      const dayLabel = priceEl.dataset.dayLabel || 'Tag';
      priceEl.textContent = `${pill.dataset.price}/${dayLabel}`;
    }

    if (totalEl && pill.dataset.priceDefault) {
      const totalLabel = totalEl.dataset.totalLabel || 'Gesamt';
      totalEl.textContent = `${pill.dataset.priceDefault}/${totalLabel}`;
    }

    if (strikeEl) {
      strikeEl.style.display = pill.dataset.strikePrice ? '' : 'none';
      if (pill.dataset.strikePrice) strikeEl.textContent = pill.dataset.strikePrice;
    }
  }

  triggerRadioForPill(pill, type) {
    if (!this.variantSelects) return;

    const optionName = pill.dataset.value;
    const optionInfos = this.variantSelects.querySelectorAll(`.option__info[data-type="${type}"]`);

    for (const info of optionInfos) {
      const nameEl = info.querySelector('.option__info-name span.h5');
      if (nameEl?.textContent.trim() === optionName) {
        info.closest('.variant-option_package')?.click();
        break;
      }
    }
  }
}

customElements.define('plan-picker-v2-ab', PlanPickerV2Ab);
